export var ForecastConfigInclude = {
    forecasts: true,
    scenario: true,
    region: true,
    closedPeriod: true,
    businessUnit: true,
};
//# sourceMappingURL=ForecastConfig.js.map